<script context="module">
  export const ITEM_TYPE_ICON_CLASSES = {
    multiple: "t-icon-tickets",
    TicketType: "t-icon-entry_ticket",
    MerchandiseType: "t-icon-goods_ticket",
    FoodBeverageType: "t-icon-fb_ticket",
    LodgingType: "t-icon-lodging_ticket",
    TransportationType: "t-icon-transport_ticket",
    SeasonPassType: "t-icon-season_pass_ticket ",
    SeasonPassShadowType: "t-icon-season_pass_ticket ",
    GiftCardType: "t-icon-gift_card_ticket ",
    CashFreeType: "t-icon-cash-free_ticket ",
    DonationType: "t-icon-donation_ticket ",
    MembershipType: "t-icon-membership ",
    ClickCardType: "t-icon-click-card_ticket ",
    VoucherType: "t-icon-voucher_ticket ",
    StreamType: "t-icon-pay-per-view_ticket",
    VideoOnDemandType: "t-icon-video-on-demand_ticket",
    OpenBundleType: "t-icon-bundle_ticket",
    ClosedBundleType: "t-icon-bundle_ticket",
    SubscriptionShadowType: "t-icon-subscription_ticket",
    SubscriptionType: "t-icon-subscription_ticket",
  };
</script>

<script>
  export let type;
  export let size;

  let className = $$restProps.class || null;

  const sizes = {
    medium: "t-icon__medium",
    big: "t-icon__big",
    huge: "t-icon__huge",
  };

  function getClassName(x) {
    let classes = [];
    let selectedType = ITEM_TYPE_ICON_CLASSES[x.type] || "t-icon-entry_ticket";

    classes.push(selectedType);

    var selectedSize = sizes[x.size];

    classes.push(selectedSize);
    classes.push(x.className);

    return classes.filter(Boolean).join(" ");
  }
</script>

<i class={getClassName({ type: type, size: size, className: className })} />
